import { useInstantSearch } from 'react-instantsearch-core';
import { useIntl } from 'react-intl';

import { getStoreLabelMap } from '../../helpers';
import type { ListingFiltersVariant } from '../../types';
import { FilterAppliedButton } from '../FilterAppliedButton/FilterAppliedButton';
import { FiltersClearButton } from '../FiltersClearButton';
import { RangeAppliedButton } from '../RangeAppliedButton/RangeAppliedButton';
import { getSwatchFilterItemValues } from '../SwatchFilter/utils';
import { getOrderedAppliedFilters } from './utils';

import * as S from './FiltersApplied.styles';

interface FiltersAppliedProps {
  variant?: ListingFiltersVariant;
}

export const FiltersApplied = ({
  variant = 'default',
}: FiltersAppliedProps) => {
  const { formatMessage } = useIntl();

  const storeLabelMap = getStoreLabelMap(formatMessage);

  const { indexUiState } = useInstantSearch();

  const refinementList = indexUiState.refinementList || {};
  const hasAppliedFilters = Object.keys(refinementList).length > 0;
  const hasRangeFilters = indexUiState.range?.price !== '';

  if (!hasAppliedFilters && !hasRangeFilters) {
    return null;
  }

  const search = typeof window !== 'undefined' ? window.location.search : '';
  const orderedEntries = getOrderedAppliedFilters(refinementList, search);

  return (
    <S.FiltersAppliedButtonList data-test-id='FiltersApplied'>
      {orderedEntries.map(([attribute, values]) =>
        values.map((item, index) => {
          // getSwatchFilterItemValues returns the first part before the pipe
          const { name } = getSwatchFilterItemValues(item);

          const formattedName = (storeLabelMap[name] || name).replaceAll(
            '_',
            ' ',
          );
          return (
            <FilterAppliedButton
              key={`${attribute}-${item}-${index}`}
              attribute={attribute}
              item={item}
              name={formattedName}
            />
          );
        }),
      )}
      <RangeAppliedButton />
      <FiltersClearButton
        data-test-id='ListingFiltersClearButton'
        variant={variant}
      />
    </S.FiltersAppliedButtonList>
  );
};
